import api from './api';

export interface HashtagResponse {
    hashtags: string[];
}

export interface CaptionResponse {
    caption: string;
}

export interface BestTimeToPostResponse {
    suggestions: { platform: string; time: string }[];
}

class AIService {
    async generateHashtagsFromText(text: string): Promise<HashtagResponse> {
        const response = await api.post<HashtagResponse>('/ai/generate-hashtags-from-text', { text });
        return response.data;
    }

    async generateHashtagsFromImage(mediaFileId: string, caption?: string, useBrandContext: boolean = true): Promise<HashtagResponse> {
        const payload: { media_file_id: string, caption?: string, use_brand_context?: boolean } = { 
            media_file_id: mediaFileId,
            use_brand_context: useBrandContext
        };
        if (caption) {
            payload.caption = caption;
        }
        // Use a longer timeout for AI operations
        const response = await api.post<HashtagResponse>(
            '/ai/generate-hashtags-from-image', 
            payload,
            { timeout: 50000 } // 50 second timeout for AI operations
        );
        return response.data;
    }

    async generateCaptionFromImage(mediaFileId: string, useBrandContext: boolean = true): Promise<CaptionResponse> {
        // Use a longer timeout for AI operations
        const response = await api.post<CaptionResponse>(
            '/ai/generate-caption-from-image', 
            { 
                media_file_id: mediaFileId,
                use_brand_context: useBrandContext
            },
            { timeout: 50000 } // 50 second timeout for AI operations
        );
        return response.data;
    }

    async getBestTimeToPost(): Promise<BestTimeToPostResponse> {
        try {
            const response = await api.get('/social/best-time-to-post');
            return response.data;
        } catch (error) {
            console.error('Error fetching best time to post:', error);
            // Return empty suggestions on error
            return { suggestions: [] };
        }
    }
}

export const aiService = new AIService();
